import { cn } from '@avanta/shared/utils/cn';
import { type ReactElement, memo } from 'react';
import { type SapaMessageProps } from './types';

const SapaMessage = ({ isUser = false, date, children }: SapaMessageProps): ReactElement => (
  <div className={cn('flex flex-col', isUser && 'items-end')}>
    <div
      className={cn(
        'flex flex-col gap-2 w-full',
        isUser ? 'max-w-[50%] md:max-w-[25%]' : 'max-w-full md:max-w-[75%]'
      )}
    >
      {date && <p className="text-sm text-gray-500 text-right">{date}</p>}
      <div
        className={cn(
          'flex flex-col gap-2 w-full p-4 rounded-2xl',
          isUser
            ? 'bg-teal-200 text-denim-500 rounded-tr-none'
            : 'bg-white border border-gray-200 rounded-tl-none'
        )}
      >
        <span className="whitespace-pre-line wrap-break-word">{children}</span>
      </div>
    </div>
  </div>
);

export default memo(SapaMessage);
